import React, { useState } from "react";
import { useRef } from 'react';
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css"; 
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

const Icons = {
  Folder: () => (
    <svg className="folder-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
    </svg>
  ),
  ChevronDown: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 9l6 6 6-6" />
    </svg>
  ),
  File: ({ color = "currentColor" }) => (
    <svg className="doc-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
       <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
       <polyline points="14 2 14 8 20 8"></polyline>
    </svg>
  ),
  Users: ({ color = "currentColor" }) => (
    <svg className="doc-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Megaphone: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11 5L6 9H2v6h4l5 4V5z"></path>
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
    </svg>
  )
};

const PhdDocument = () => {
  const topRef = useRef(null);
  const [openSection, setOpenSection] = useState("phd-2024"); 
const [showForm, setShowForm] = useState(false);

  const navigationData = [
    {
      id: "phd-2024",
      title: "Ph.D. Admission 2024-25",
      type: "group",
      items: [
        { id: "adv-24", title: "Advertisement", src: "/pdf/program/phd/Final_PhD-AD-2024-25-9-6x12cm-Outline (1).pdf", iconColor: "#3f3d9b", type: "pdf" },
        { id: "form-24", title: "Admission Form 2024-25", src: "/pdf/program/phd/PhD-Admission_Form-24-25-New.pdf", iconColor: "#3f3d9b", type: "pdf" }
      ]
    },
    {
      id: "aicte",
      title: "Ordinance and Circulars",
      type: "group",
      items: [
        { id: "work-syllabus", title: "PhD Course Work Syllabus", src: "/pdf/program/phd/PhD-Course-work-detail_new.pdf", iconColor: "#3f3d9b", type: "pdf" },
        { id: "ethics-work", title: "Circular for Research Ethics in PhD Course Work", src: "/pdf/program/phd/Circular-for-Reserach-Ethics-in-Ph.D.-Course-work-1.pdf", iconColor: "#3f3d9b", type: "pdf" },
        { id: "elig-tech", title: "Circular for Eligibility for PhD in Faculty of Technology", src: "/pdf/program/phd/4405511_Draft-UGC-PhD-regulations-2022.pdf", iconColor: "#3f3d9b", type: "pdf" },
      ]
    },
    {
      id: "enrolled",
      title: "Enrolled Students",
      type: "group",
      items: [
        { id: "enrolled-list", title: "List of Enrolled Students", src: null, iconColor: "#3f3d9b", type: "table" }
      ]
    }
  ];

  const [activePdf, setActivePdf] = useState(navigationData[0].items[0]);

  const toggleSection = (id) => {
    setOpenSection(openSection === id ? null : id);
  };

  const handlePdfSelection = (item) => {
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    setActivePdf(item);
  };

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="spv-modern-portal phd-document-portal">
        <div ref={topRef}>
          <PageHeader 
            title="Ph.D. Admission" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Ph.D. Admission' }]} 
          />
          {showForm && <BrochureForm setShowForm={setShowForm} />}
        </div>

        <div className="spv-main-content">
          {/* --- SIDEBAR --- */}
          <aside className="spv-sidebar-modern">
            <div className="phd-sidebar-box">
              <div className="spv-sidebar-header-text">DOCUMENT REPOSITORY</div>
              <div className="spv-nav-group">
                {navigationData.map((section) => {
                  const isCurrentSectionActive = section.items.some(item => item.id === activePdf.id);
                  return (
                    <div key={section.id} className={`spv-accordion-item ${isCurrentSectionActive ? 'has-active-child' : ''}`}>
                      <button 
                        className={`spv-accordion-header ${openSection === section.id ? 'active' : ''}`}
                        onClick={() => toggleSection(section.id)}
                      >
                        <div className="spv-acc-left">
                          <Icons.Folder />
                          <span className="spv-acc-title">{section.title}</span>
                        </div>
                        <span className={`spv-acc-chevron ${openSection === section.id ? 'rotate' : ''}`}>
                          <Icons.ChevronDown />
                        </span>
                      </button>

                      <div className={`spv-accordion-body ${openSection === section.id ? 'open' : ''}`}>
                        {section.items.map((item) => (
                          <button
                            key={item.id}
                            className={`spv-sub-item ${activePdf.id === item.id ? "is-active" : ""}`}
                            onClick={() => handlePdfSelection(item)}
                          >
                            <span className="spv-sub-icon">
                              {item.type === 'table' ? (
                                <Icons.Users color={item.iconColor} />
                              ) : (
                                <Icons.File color={item.iconColor} />
                              )}
                            </span>
                            <span className="spv-sub-title-text">{item.title}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </aside>

          {/* --- MAIN VIEWER --- */}
          <main className="spv-viewer-area">
            <div className="phd-viewer-box">
              <header className="spv-viewer-topbar">
                <div className="spv-info-stack">
                  <span className="phd-title-icon" aria-hidden="true">
                    <Icons.Megaphone />
                  </span>
                  <h2 className="spv-doc-title">{activePdf.title}</h2>
                </div>
                <div className="spv-action-group">
                  {activePdf.type !== 'table' && (
                    <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src)}>
                      Open Full Screen
                    </button>
                  )}
                </div>
              </header>

              <div className="spv-pdf-viewport">
                <div className="spv-pdf-card no-select" style={{ overflowY: activePdf.type === 'table' ? 'auto' : 'hidden' }}>
                  {activePdf.type === 'table' ? (
                    <div className="table-container">
                      <table className="responsive-table">
                          <thead>
                              <tr>
                                  <th>Sr. No.</th>
                                  <th>Batch</th>
                                  <th>Name</th>
                                  <th>Qualification</th>
                                  <th>Eligibility (PET/NET)</th>
                                  <th>Email</th>
                                  <th>Name of Supervisor</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr>
                                  <td>1</td>
                                  <td>Jan-25</td>
                                  <td>Mr. Shirshendu Maitra</td>
                                  <td>MCA</td>
                                  <td>PET</td>
                                  <td>slm2007@gmail.com</td>
                                  <td rowSpan="4" style={{verticalAlign: 'middle'}}>Dr. Vinita Gaikwad</td>
                              </tr>
                              <tr>
                                  <td>2</td>
                                  <td>Jan-25</td>
                                  <td>Ms. Mira Gohil</td>
                                  <td>MCA, MPhil</td>
                                  <td>MPhil</td>
                                  <td>miragohil260178@gmail.com</td>
                              </tr>
                              <tr>
                                  <td>3</td>
                                  <td>Jan-25</td>
                                  <td>Ms. Rohini Bagul</td>
                                  <td>MCA</td>
                                  <td>NET</td>
                                  <td>rohinisanjeev06@gmail.com</td>
                              </tr>
                              <tr>
                                  <td>4</td>
                                  <td>Jan-25</td>
                                  <td>Ms. Crimita Pereira</td>
                                  <td>MSc IT</td>
                                  <td>NET</td>
                                  <td>crimitaa@gmail.com</td>
                              </tr>
                          </tbody>
                      </table>
                    </div>
                  ) : (
                    <iframe
                      src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                      className="spv-iframe-content secure-frame"
                      title="Document Viewer"
                      onContextMenu={(e) => e.preventDefault()}
                    />
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
       <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </>
  );
};

export default PhdDocument;